export enum EDruhUplatneni {
    E = 'E',
    A = 'A',
    B = 'B',
    O = 'O'
}
